<div class="flex w-full h-[6vh] items-center justify-between overflow-hiddenw">
  <div class="flex w-1/2 justify-start items-center">
    <div class="flex items-center justify-start w-fit ">
      <h1
        class="font-avantgarde text-[4.63vh] font-bold text-left text-[var(--quaternary)]">
        Da
      </h1>
      <h1
        class="font-avantgarde text-[4.63vh] font-normal text-left text-[var(--quaternary)]">
        Pico
      </h1>
    </div>
    <div
      class="bg-[var(--quaternary)] w-fit h-[4.537vh] rounded-[0.787vh] shadow-custom flex justify-center items-center ml-[0.520vw] py-[0.556vh] px-[0.556vh]">
      <div class=" ">
        <h1 class="text-[var(--tertiary)] font-avantgarde text-[3.333vh] leading-7 font-bold w-full ">
          HR
        </h1>
      </div>
    </div>
  </div>
  <div class="flex justify-end w-full items-center lg:hidden" *ngIf="!showRingraziamenti">
    <div class="p-[1vh] rounded-full bg-bar" (click)="setRiepilogo()">
      <svg *ngIf="this.showRiepilogo" class=" fill-[var(--tertiary)] h-[2.05vh] w-[2.05vh]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
  
      <svg *ngIf="!this.showRiepilogo" class=" h-[2.05vh] w-[2.05vh]" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M7.81348 7.03256H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M7.81348 12.5012H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M7.81348 17.9707H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M3.9145 7.82802C4.34985 7.82802 4.70278 7.4751 4.70278 7.03974C4.70278 6.60439 4.34985 6.25146 3.9145 6.25146C3.47914 6.25146 3.12622 6.60439 3.12622 7.03974C3.12622 7.4751 3.47914 7.82802 3.9145 7.82802Z"
          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M3.9145 13.2966C4.34985 13.2966 4.70278 12.9437 4.70278 12.5083C4.70278 12.073 4.34985 11.7201 3.9145 11.7201C3.47914 11.7201 3.12622 12.073 3.12622 12.5083C3.12622 12.9437 3.47914 13.2966 3.9145 13.2966Z"
          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M3.9145 18.7658C4.34985 18.7658 4.70278 18.4129 4.70278 17.9775C4.70278 17.5422 4.34985 17.1893 3.9145 17.1893C3.47914 17.1893 3.12622 17.5422 3.12622 17.9775C3.12622 18.4129 3.47914 18.7658 3.9145 18.7658Z"
          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

  </div>
  <div class="hidden lg:flex lg:items-center lg:w-1/2 lg:justify-end ">

    <div class="size-full flex justify-end items-center  overflow-x-auto">
      <!-- <app-stepper class="w-full" ></app-stepper> -->
      <div class="whitespace-nowrap text-[2.037vh] text-[var(--tertiary)] mr-[1vw]">Progresso del questionario</div>
      <app-progress-bar [current]="stepperService.currentQuestion" [total]="stepperService.totalQuestion"
        class="w-full"></app-progress-bar>
    </div>
  </div>
  
</div>
<div class="lg:hidden mb-[2vh] mt-[1vh]">
  <div class="whitespace-nowrap text-[2.037vh] text-[var(--tertiary)] mb-[1vh]">Progresso del questionario</div>
  <app-progress-bar [current]="stepperService.currentQuestion" [total]="stepperService.totalQuestion"
      class="w-full"></app-progress-bar>
</div>
<div class=" justify-end w-full items-center hidden lg:flex" *ngIf="!showRingraziamenti">
  <div class="p-[1vh] rounded-full bg-bar" (click)="setRiepilogo()">
    <svg *ngIf="this.showRiepilogo" class=" fill-[var(--tertiary)] h-[2.05vh] w-[2.05vh]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>

    <svg *ngIf="!this.showRiepilogo" class=" h-[2.05vh] w-[2.05vh]" viewBox="0 0 25 25" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M7.81348 7.03256H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.81348 12.5012H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.81348 17.9707H21.876" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M3.9145 7.82802C4.34985 7.82802 4.70278 7.4751 4.70278 7.03974C4.70278 6.60439 4.34985 6.25146 3.9145 6.25146C3.47914 6.25146 3.12622 6.60439 3.12622 7.03974C3.12622 7.4751 3.47914 7.82802 3.9145 7.82802Z"
        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M3.9145 13.2966C4.34985 13.2966 4.70278 12.9437 4.70278 12.5083C4.70278 12.073 4.34985 11.7201 3.9145 11.7201C3.47914 11.7201 3.12622 12.073 3.12622 12.5083C3.12622 12.9437 3.47914 13.2966 3.9145 13.2966Z"
        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M3.9145 18.7658C4.34985 18.7658 4.70278 18.4129 4.70278 17.9775C4.70278 17.5422 4.34985 17.1893 3.9145 17.1893C3.47914 17.1893 3.12622 17.5422 3.12622 17.9775C3.12622 18.4129 3.47914 18.7658 3.9145 18.7658Z"
        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>

</div>